import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Entity, Guard, Result } from '@digibricks/core';
import { SubmissionScore } from '../submission-score';
import { AnswerComment } from '../answer-comment';
import { Comment } from '../comment';
export var Answer = /*#__PURE__*/function (_Entity) {
  _inherits(Answer, _Entity);

  var _super = _createSuper(Answer);

  function Answer() {
    _classCallCheck(this, Answer);

    return _super.apply(this, arguments);
  }

  _createClass(Answer, [{
    key: "sectionId",
    get: function get() {
      return this.props.sectionId;
    }
  }, {
    key: "questionId",
    get: function get() {
      return this.props.questionId;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "score",
    get: function get() {
      var _this$props, _this$props$score;

      return (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$score = _this$props.score) === null || _this$props$score === void 0 ? void 0 : _this$props$score.value;
    }
  }, {
    key: "comment",
    get: function get() {
      return this.props.comment;
    }
  }, {
    key: "answerComment",
    get: function get() {
      return this.props.answerComment;
    }
  }, {
    key: "hasGraded",
    value: function hasGraded() {
      var _this$props2, _this$props2$score;

      return this.props.score && ((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$score = _this$props2.score) === null || _this$props2$score === void 0 ? void 0 : _this$props2$score.value) !== SubmissionScore["default"].value;
    }
  }, {
    key: "updateScore",
    value: function updateScore(score) {
      this.props.score = SubmissionScore.create(score).getValue();
    }
  }, {
    key: "updateComment",
    value: function updateComment(comment) {
      this.props.comment = comment;
    }
  }, {
    key: "isEmptyComment",
    value: function isEmptyComment() {
      return !this.comment || this.comment === '<p></p>' || this.comment === '<p><br></p>';
    }
  }, {
    key: "addAnswerComment",
    value: function addAnswerComment(commentContent, commentId, submissionAnswerContent) {
      if (!this.props.answerComment) {
        this.props.answerComment = AnswerComment["default"];
      }

      var resultOrError = this.props.answerComment.addComment(commentContent, commentId, submissionAnswerContent);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      return Result.ok();
    }
  }, {
    key: "editAnswerComment",
    value: function editAnswerComment(updatedComment, submissionAnswerContent) {
      if (!this.props.answerComment) {
        return new BadInputError('Answer Comment is not found');
      }

      var isExistCommentIdInAnswerContent = this.props.answerComment.submissionAnswerContent.includes(updatedComment.id.toString());

      if (!isExistCommentIdInAnswerContent) {
        return new BadInputError("Comment ".concat(updatedComment.id.toString(), " cannot be found in Submission Answer Content"));
      }

      var foundComment = this.props.answerComment.comments.find(function (c) {
        return c.id.toString() === updatedComment.id.toString();
      });

      if (!foundComment) {
        return new BadInputError("Comment ".concat(updatedComment.id.toString(), " cannot be found in Comment List"));
      }

      this.props.answerComment.editComment(updatedComment.content, updatedComment.id.toString());
      this.props.answerComment.updateSubmissionAnswerContent(submissionAnswerContent);
      return Result.ok();
    }
  }, {
    key: "deleteAnswerComment",
    value: function deleteAnswerComment(commentId, submissionAnswerContent) {
      var answerComment = this.props.answerComment;

      if (!answerComment) {
        return new BadInputError('Answer Comment is not found');
      }

      var isExistComment = answerComment.comments.find(function (c) {
        return c.id.toString() === commentId;
      });

      if (!isExistComment) {
        return new BadInputError("Comment ".concat(commentId, " cannot be found"));
      }

      var foundCommentOrError = Comment.create(isExistComment, commentId);

      if (foundCommentOrError.isFailure) {
        return Result.fail(foundCommentOrError.error);
      }

      answerComment.deleteComment(commentId);
      answerComment.updateSubmissionAnswerContent(submissionAnswerContent);
      return Result.ok();
    }
  }], [{
    key: "createBaseProps",
    value: function createBaseProps(props) {
      var collection = [{
        argument: props.id,
        argumentName: 'Answer Id'
      }, {
        argument: props.sectionId,
        argumentName: 'Section Id'
      }, {
        argument: props.questionId,
        argumentName: 'Question Id'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      return Result.ok(props);
    }
  }]);

  return Answer;
}(Entity);